import styled from "styled-components";
import { Link } from "react-router-dom";

export const Header = styled.header`
  position: fixed;
  top: 0;
  right: 0;
  height: 42px;
  width: 100%;
  z-index: 2;
  padding-top: 10px;

  text-align: right;

  transition: background 0.6s;

  > a {
    color: var(--black);
    transition: 0.4s;
  }
`;

export const LinkMenu = styled(Link)`
  margin: 10px;
  width: 100px;

  text-decoration: none;
  font-weight: bold;

  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.6;
  }
`;
